/**
 * @module 外部リンク_コンポーネント
 */
/* 外部リンクを開く時のURLを記述する */

const userAgent = navigator.userAgent;
let os = '';
let domain = `${window.location.protocol + '//' + window.location.host}/`;

if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  os = 'ios';
}

if (/android/i.test(userAgent)) {
  os = 'android';
}

const externalUrl = {
  // ヘッダ
  shop: 'https://guardman-shop.com',
  // ユーザーマニュアル
  manual: domain + 'hs-static/UserManual_S-730_jp.pdf',
  manualEn: domain + 'hs-static/UserManual_S-730_en.pdf',

  // FE-CU54_thanks画面
  alsokInquiry: 'https://www.alsok.co.jp/company/info/office/',
  // FE-CU31_各種設定画面
  // alsockWeAppDisplayDistrictAccountManagement: 'https://ドメイン/displayDistrictAccountManagement',
  // alsockWebAppCameraAccountManagement: 'https://ドメイン/cameraAccountManagement',
  // alsockWebAppUserInfoAccountManagement: 'https://ドメイン/userInfoAccountManagement',
  alsockWeAppDisplayDistrictAccountManagement:
    os == 'ios'
      ? `${window.location.protocol + '//' + window.location.host}/` +
        encodeURIComponent('#') +
        `/displayDistrictAccountManagement`
      : `${
          window.location.protocol + '//' + window.location.host
        }/#/displayDistrictAccountManagement`,
  alsockWebAppCameraAccountManagement:
    os == 'ios'
      ? `${window.location.protocol + '//' + window.location.host}/` +
        encodeURIComponent('#') +
        `/cameraAccountManagement`
      : `${window.location.protocol + '//' + window.location.host}/#/cameraAccountManagement`,
  alsockWebAppUserInfoAccountManagement:
    os == 'ios'
      ? `${window.location.protocol + '//' + window.location.host}/` +
        encodeURIComponent('#') +
        `/userInfoAccountManagement`
      : `${window.location.protocol + '//' + window.location.host}/#/userInfoAccountManagement`,
  alsockWebAppServiceAddManagement:
    os == 'ios'
      ? `${window.location.protocol + '//' + window.location.host}/` +
        encodeURIComponent('#') +
        `/serviceAdd`
      : `${window.location.protocol + '//' + window.location.host}/#/serviceAdd`,
  alsockWebAppPasswordInitUserIdEntry:
    os == 'ios'
      ? `${window.location.protocol + '//' + window.location.host}/` +
        encodeURIComponent('#') +
        `/passwordInitUserIdEntry`
      : `${window.location.protocol + '//' + window.location.host}/#/passwordInitUserIdEntry`,
  alsockWebAppApprovalTerms:
    os == 'ios'
      ? `${window.location.protocol + '//' + window.location.host}/` +
        encodeURIComponent('#') +
        `/approvalTerms`
      : `${window.location.protocol + '//' + window.location.host}/#/approvalTerms`,

  // HomeLink関連
  homeLinkPlayStoreUrl: 'https://play.google.com/store/apps/details?id=jp.co.linkjapan.elife',
  homeLinkStoreUrl: 'https://apps.apple.com/jp/app/homelink/id1484314576',
  homeLinkWebUrl: 'https://apps.apple.com/jp/app/homelink/id1484314576',
  homeLinkWebPlayStoreUrl: 'https://play.google.com/store/apps/details?id=jp.co.linkjapan.elife',
};

export default externalUrl;
